import { render } from "./GeneralMedicine.vue?vue&type=template&id=71c8b400"
import script from "./GeneralMedicine.vue?vue&type=script&lang=ts"
export * from "./GeneralMedicine.vue?vue&type=script&lang=ts"
script.render = render

export default script